import React from "react";
import CareerSkillsSection from "../Shared/CareerSkillsSection";

const CyberCareerSkills = () => {
    return (
        <CareerSkillsSection
            title="CYBERSECURITY SKILLS? LOCKED IN."
            paragraphs={[
                "In Cybersecurity at JRIIT, you’ll master protecting data, networks, and systems from threats. Learn to fight real-world cyberattacks with hands-on labs and simulations.",
                "Our approach emphasizes ethical hacking, threat analysis, and defense systems. Employers trust JRIIT graduates to keep their organizations safe.",
                "Choose a Certificate for rapid skills or a Diploma for advanced defense mastery.",
            ]}
        />
    );
};

export default CyberCareerSkills;
